const urlParamKeys = {
  assetClassKey: 'assetClassKey',
  dateAsOf: 'dateAsOf',
  name: 'name',
  email: 'email',
  key: 'key',
};

export default urlParamKeys;
